const formatter = new Intl.NumberFormat('nl-BE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const formatCurrency = (num: number) => formatter.format(num) + " €";
export const formatPct = (num: number) => formatter.format(num) + " %";
export const formatAmount = (num: number) => num.toFixed(0);
export const formatNumber = (num: number) => formatter.format(num);